const GUEST_CONTACT_FIELDS = new Set([
  "GuestEmail",
  "GuestPhone",
  "PrevGuestEmail",
  "PrevGuestPhone",
  "NextGuestEmail",
  "NextGuestPhone",
]);

const sanitizeValue = (value, insideGuestDetails = false) => {
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeValue(item, insideGuestDetails));
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  return Object.entries(value).reduce((sanitized, [key, nestedValue]) => {
    const isGuestContact =
      GUEST_CONTACT_FIELDS.has(key) ||
      (insideGuestDetails && (key === "Email" || key === "Phone"));

    if (!isGuestContact) {
      sanitized[key] = sanitizeValue(
        nestedValue,
        insideGuestDetails || key === "GuestDetails"
      );
    }

    return sanitized;
  }, {});
};

/**
 * Removes guest-only email and phone fields from Staff Dashboard payloads.
 * Names and non-guest contact objects are preserved.
 */
export const sanitizeGuestContactData = (payload) => sanitizeValue(payload);

